<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [style]="{ width: '1140px' }"
  [breakpoints]="{ '1200px': '96vw' }"
  styleClass="wl-detail-dialog">

  <!-- El título ES el encabezado del diálogo, no la primera línea del contenido: el header de
       PrimeNG no scrollea, así que el folio, el título y los controles de la tarea siguen a la
       vista al bajar hasta la Bitácora. Antes desaparecían con el scroll y arriba quedaba una
       franja vacía con la ✕. -->
  <ng-template pTemplate="header">
    <div class="wl-head" *ngIf="item; else headLoading">
      <h2 class="wl-d-title" [title]="item.title">
        <span class="wl-code" *ngIf="item.code">{{ item.code }}</span>{{ item.title }}
      </h2>

      <!-- Todas las etiquetas de la tarea en una sola fila: tipo, estado, origen y áreas -->
      <div class="wl-tags">
        <span class="wl-type" [style.background]="TYPE_META[item.type].color + '1a'" [style.color]="TYPE_META[item.type].color">
          <i [class]="TYPE_META[item.type].icon"></i> {{ TYPE_META[item.type].label }}
        </span>

        <!-- El badge de estado ES el control para moverla: al hacer clic despliega los destinos
             válidos. Solo un dev con transiciones disponibles lo ve como botón; para el resto
             (y en estados terminales) es una etiqueta plana. La otra vía es el drag del tablero. -->
        <button *ngIf="canChangeStatus; else statusPlain" type="button" class="wl-status is-clickable"
          [style.background]="STATUS_META[item.status].color" (click)="statusPanel.toggle($event)"
          title="Cambiar de estado">
          <i [class]="STATUS_META[item.status].icon"></i> {{ STATUS_META[item.status].label }}
          <i class="fa-solid fa-chevron-down wl-caret"></i>
        </button>
        <ng-template #statusPlain>
          <span class="wl-status" [style.background]="STATUS_META[item.status].color">
            <i [class]="STATUS_META[item.status].icon"></i> {{ STATUS_META[item.status].label }}
          </span>
        </ng-template>

        <!-- Origen: lo deriva el backend de quién dio el alta (dev humano = Extra, cualquier
             otro interno = Solicitada). Un isDev puede corregirlo con un clic — alimenta el KPI
             de aportes; el backend se lo veta a la identidad de máquina. -->
        <button *ngIf="isDev; else originPlain" type="button" class="wl-origin is-clickable" [style.color]="ORIGIN_META[item.origin].color"
          (click)="toggleOrigin()" [title]="'Cambiar a ' + (item.origin === 'proposed' ? 'Solicitada' : 'Extra')">
          <i [class]="ORIGIN_META[item.origin].icon"></i> {{ ORIGIN_META[item.origin].label }}
        </button>
        <ng-template #originPlain>
          <span class="wl-origin" [style.color]="ORIGIN_META[item.origin].color">
            <i [class]="ORIGIN_META[item.origin].icon"></i> {{ ORIGIN_META[item.origin].label }}
          </span>
        </ng-template>

        <span class="wl-area" *ngFor="let a of item.areas" [style.background]="areaMeta(a)?.color + '1a'" [style.color]="areaMeta(a)?.color">
          <i [class]="areaMeta(a)?.icon"></i> {{ areaMeta(a)?.label }}
        </span>
      </div>
    </div>

    <!-- Borrar vive con los controles de ventana, no colgando al final de las etiquetas: ahí
         flotaba a media fila, lejos de todo, sin nada con qué alinearse. Solo se ofrece mientras
         la tarea siga en Backlog y a quien la registró (o a un Admin): es para el alta
         equivocada, no para descartar trabajo. Lo demás se cancela. -->
    <button type="button" class="wl-head-del" *ngIf="canDelete" (click)="askDelete()"
      title="Borrar esta tarea definitivamente" aria-label="Borrar esta tarea">
      <i class="fa-solid fa-trash-can"></i>
    </button>
    <!-- Sin esto el encabezado nace vacío y salta de alto en cuanto responde la API. -->
    <ng-template #headLoading>
      <div class="wl-head"><h2 class="wl-d-title is-skeleton">Cargando tarea…</h2></div>
    </ng-template>
  </ng-template>

  <div class="wl-detail" *ngIf="item && !loading">
    <!-- Dos columnas: a la izquierda lo que se lee (el intake y los archivos), a la derecha lo
         que se consulta de reojo (la bitácora). Antes iba todo apilado y el historial quedaba a
         dos pantallas de scroll del título. -->
    <div class="wl-cols">
    <div class="wl-col-main">

    <!-- La clasificación sigue en línea a propósito: no es una confirmación de sí/no sino un
         formulario corto que se llena mirando la tarea que está detrás. -->

    <!-- Clasificación obligatoria al terminar el desarrollo (gate a To Deploy, D10) -->
    <div class="wl-ask-points" *ngIf="askingPoints">
      <div class="wl-ask-head">
        <i class="fa-solid fa-bullseye"></i>
        <div>
          <strong>Antes de entregar</strong>
          <span>El desarrollo terminó: ¿cuánto costó y qué tocó? Se registra al mandarla a To Deploy.</span>
        </div>
      </div>

      <label class="wl-ask-label">Esfuerzo</label>
      <div class="wl-points big">
        <button type="button" *ngFor="let p of EFFORT_POINTS" [class.on]="chosenPoints === p.value"
          [title]="p.hint" (click)="pickPoints(p.value)">{{ p.value }}</button>
      </div>
      <p class="wl-ask-hint" *ngIf="chosenPoints">{{ pointsHint }}</p>

      <label class="wl-ask-label">Áreas que tocó</label>
      <div class="wl-ask-areas">
        <button type="button" *ngFor="let a of AREA_ORDER" [class.on]="chosenAreas.includes(a)"
          [style.--area]="areaMeta(a)?.color" (click)="toggleArea(a)">
          <i [class]="areaMeta(a)?.icon"></i> {{ areaMeta(a)?.label }}
        </button>
      </div>

      <!-- F-156: con dos o más áreas, cuántos de los puntos fueron de cada una. Así los frentes de
           las métricas suman el total en vez de contar la tarea completa en cada capa. -->
      <ng-container *ngIf="chosenPoints != null && chosenAreas.length > 1">
        <span class="wl-ask-label">¿Cuántos de los {{ chosenPoints }} puntos fueron de cada área?</span>
        <app-worklog-area-split
          [points]="chosenPoints"
          [areas]="$any(chosenAreas)"
          [split]="chosenAreaPoints"
          (splitChange)="chosenAreaPoints = $event"
        ></app-worklog-area-split>
      </ng-container>

      <div class="wl-ask-actions">
        <button type="button" class="wl-btn ghost" (click)="cancelPoints()">Cancelar</button>
        <button type="button" class="wl-btn primary" [disabled]="!canConfirmPoints" (click)="confirmPoints()">
          <i class="fa-solid fa-arrow-right"></i> Mover a {{ moveTarget ? statusLabel(moveTarget) : '' }}
        </button>
      </div>
    </div>

    <!-- Ficha: quién, cuándo y con qué compromiso. Una banda tintada, no una tarjeta: el cambio
         de fondo basta para decir "esto es otra cosa que el texto de abajo", y encajar campos con
         su propio recuadro dentro de una tarjeta era caja dentro de caja. -->
    <section class="wl-ficha">
      <div class="wl-meta-grid">
      <div class="wl-meta">
        <span class="k"><i class="fa-solid fa-user-pen"></i> Solicitó</span>
        <span class="v"><span class="ava">{{ initials(item.createdBy) }}</span> {{ userName(item.createdBy) }}</span>
      </div>
      <div class="wl-meta">
        <span class="k"><i class="fa-solid fa-calendar-day"></i> Fecha</span>
        <span class="v">{{ item.createdAt | date: 'dd MMM y, HH:mm' }}</span>
      </div>
      <div class="wl-meta">
        <span class="k"><i class="fa-solid fa-user-gear"></i> Asignado</span>
        <!-- Reasignación en vivo (isDev): usa el catálogo de devs (GET /users/devs). -->
        <p-dropdown *ngIf="isDev; else assigneePlain" [options]="devOptions" [ngModel]="assigneeId"
          (onChange)="setAssignee($event.value)" placeholder="Sin asignar" appendTo="body"
          styleClass="wl-due-dd"></p-dropdown>
        <ng-template #assigneePlain>
          <span class="v"><span class="ava" *ngIf="item.assignee">{{ initials(item.assignee) }}</span> {{ userName(item.assignee) }}</span>
        </ng-template>
      </div>
      <!-- Compromiso de entrega: lo fija el equipo de desarrollo, así que solo isDev lo edita.
           Para el resto es un dato más del expediente. -->
      <div class="wl-meta">
        <span class="k"><i class="fa-solid fa-calendar-check"></i> Entrega</span>
        <p-calendar *ngIf="isDev; else duePlain" [ngModel]="dueDate" (ngModelChange)="setDueDate($event)"
          dateFormat="dd/M/y" [showClear]="true" placeholder="Sin fecha" appendTo="body"
          styleClass="wl-due-dd"></p-calendar>
        <ng-template #duePlain>
          <span class="v">{{ item.dueDate ? (item.dueDate | date: 'dd MMM y') : '—' }}</span>
        </ng-template>
        <!-- Sin compromiso no hay nada contra qué medir el cumplimiento, y capturarlo a mano en
             un calendario es justo lo que nadie hace: el fin del sprint es el default correcto
             en la enorme mayoría de los casos, a un clic. -->
        <button type="button" class="wl-due-quick" *ngIf="canUseSprintEnd" (click)="useSprintEnd()">
          <i class="fa-solid fa-wand-magic-sparkles"></i> fin del sprint
        </button>
      </div>
      <!-- Fecha fija pedida por quien reporta, con su motivo. En rojo si el compromiso del
           equipo la rebasa (D5): visible para todos, no solo para el equipo. -->
      <div class="wl-meta" *ngIf="item.requestedDueDate">
        <span class="k"><i class="fa-solid fa-clock"></i> Fecha solicitada</span>
        <span class="v" [class.wl-risk]="dueAtRisk" [title]="item.requestedDueReason || ''">
          {{ item.requestedDueDate | date: 'dd MMM y' }}
          <i class="fa-solid fa-triangle-exclamation" *ngIf="dueAtRisk" title="El compromiso del equipo rebasa la fecha solicitada"></i>
        </span>
      </div>
      <div class="wl-meta" *ngIf="item.priority">
        <span class="k"><i class="fa-solid fa-flag"></i> Prioridad</span>
        <span class="v" [style.color]="PRIORITY_META[item.priority].color">{{ PRIORITY_META[item.priority].label }}</span>
      </div>
      <div class="wl-meta" *ngIf="item.type === 'bug' && item.severity">
        <span class="k"><i class="fa-solid fa-triangle-exclamation"></i> Severidad</span>
        <span class="v" [style.color]="SEVERITY_META[item.severity].color">{{ SEVERITY_META[item.severity].label }}</span>
      </div>
      <!-- Esfuerzo: para un isDev siempre visible y corregible (p. ej. re-calibrar tras el
           cierre); para el resto solo aparece cuando ya está puntuado. -->
      <div class="wl-meta" *ngIf="isDev || item.points != null">
        <span class="k"><i class="fa-solid fa-bullseye"></i> Puntos</span>
        <p-dropdown *ngIf="isDev; else pointsPlain" [options]="pointOptions" [ngModel]="pointsControl"
          (onChange)="setPoints($event.value)" placeholder="Sin puntuar" appendTo="body"
          styleClass="wl-due-dd"></p-dropdown>
        <ng-template #pointsPlain>
          <span class="v">{{ item.points }}</span>
        </ng-template>
        <!-- Estimado vs real: es el dato que calibra la siguiente estimación, y se calculaba solo
             agregado en el resumen del sprint — nunca donde se aprende, que es en la tarea. -->
        <small class="wl-est-drift" *ngIf="estimateDrift as d" [class]="d.level">{{ d.label }}</small>
      </div>
      <!-- F-156: cuántos de los puntos fueron de cada área. «Estimado» = nadie lo decidió y las
           métricas lo reparten en partes iguales. -->
      <div class="wl-meta" *ngIf="splitView as sv">
        <span class="k"><i class="fa-solid fa-chart-pie"></i> Reparto</span>
        <span class="v wl-split-v">
          {{ sv.label }}
          <small class="wl-split-est" *ngIf="sv.estimated">estimado</small>
          <button type="button" class="wl-split-edit-btn" *ngIf="isDev && !editingSplit" aria-label="Editar reparto" (click)="openSplitEditor()">Editar</button>
        </span>
      </div>
      </div>

      <div class="wl-split-editor" *ngIf="editingSplit && item">
        <span class="wl-ask-label">¿Cuántos de los {{ editPoints }} puntos fueron de cada área?</span>
        <app-worklog-area-split
          [points]="editPoints"
          [areas]="item.areas"
          [split]="editAreaPoints"
          (splitChange)="editAreaPoints = $event"
        ></app-worklog-area-split>
        <div class="wl-ask-actions">
          <button type="button" class="wl-btn ghost" [disabled]="savingSplit" (click)="cancelSplitEdit()">Cancelar</button>
          <button type="button" class="wl-btn primary" [disabled]="!canSaveSplit || savingSplit" (click)="saveSplit()">
            <i [class]="savingSplit ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-check'" aria-hidden="true"></i> Guardar reparto
          </button>
        </div>
      </div>
    </section>

    <!-- Lo que se pidió. Un título con su regla y aire alrededor en vez de una tarjeta: las
         cuatro piezas del intake son la misma lectura, y encerrarlas partía el hilo del texto. -->
    <section class="wl-sec" *ngIf="item.description || item.acceptanceCriteria || item.stepsToReproduce || item.expectedResult">
      <h3 class="wl-sec-title">Lo que se pidió</h3>
      <div class="wl-sec-body">
        <div class="wl-section" *ngIf="item.description">
          <h4>Descripción</h4>
          <app-worklog-rich-text [resolved]="attachmentUrls" [knownUrls]="attachmentRefs" [text]="item.description" (openImage)="openImage($event)"></app-worklog-rich-text>
        </div>
        <div class="wl-section" *ngIf="item.acceptanceCriteria">
          <h4>Criterios de aceptación</h4>
          <app-worklog-rich-text [resolved]="attachmentUrls" [knownUrls]="attachmentRefs" [text]="item.acceptanceCriteria" (openImage)="openImage($event)"></app-worklog-rich-text>
        </div>
        <div class="wl-section" *ngIf="item.stepsToReproduce">
          <h4>Pasos para reproducir</h4>
          <app-worklog-rich-text [resolved]="attachmentUrls" [knownUrls]="attachmentRefs" [text]="item.stepsToReproduce" (openImage)="openImage($event)"></app-worklog-rich-text>
        </div>
        <div class="wl-section" *ngIf="item.expectedResult">
          <h4>Resultado esperado</h4>
          <app-worklog-rich-text [resolved]="attachmentUrls" [knownUrls]="attachmentRefs" [text]="item.expectedResult" (openImage)="openImage($event)"></app-worklog-rich-text>
        </div>
      </div>
    </section>

    <!-- Archivos: lo que alguien subió A PROPÓSITO —el Excel, el PDF, el contrato—. Van aparte de
         las imágenes pegadas en los textos: revueltos, un archivo de trabajo quedaba enterrado
         entre diez capturas y no había forma de saber cuál era «el adjunto». -->
    <section class="wl-sec">
      <h3 class="wl-sec-title">
        Archivos
        <span class="wl-count" *ngIf="fileAttachments.length">{{ fileAttachments.length }}</span>
      </h3>
      <div class="wl-sec-body">
        <label class="wl-drop" (drop)="onDrop($event)" (dragover)="onDragOver($event)">
          <input type="file" multiple hidden (change)="onFilesChosen($any($event.target).files); $any($event.target).value = ''" />
          <span *ngIf="!uploading">Suelta los archivos aquí o <u>búscalos en la computadora</u></span>
          <span *ngIf="uploading"><i class="fa-solid fa-spinner fa-spin"></i> Subiendo…</span>
        </label>

        <ul class="wl-files" *ngIf="fileAttachments.length">
          <li class="wl-file" *ngFor="let a of fileAttachments">
            <!-- Una imagen subida como archivo muestra su miniatura; el resto, el ícono de su tipo. -->
            <button type="button" class="wl-file-thumb" *ngIf="isImage(a) && attachmentUrls[a.url]; else tipo"
              (click)="openImage(a.url)" [attr.aria-label]="'Ver ' + a.filename">
              <img [src]="attachmentUrls[a.url]" alt="" />
            </button>
            <ng-template #tipo>
              <span class="wl-file-thumb"><i [class]="fileIcon(a)" aria-hidden="true"></i></span>
            </ng-template>
            <span class="wl-file-txt">
              <span class="wl-file-name" [title]="a.filename">{{ a.filename }}</span>
              <span class="wl-file-meta">{{ fileSize(a.size) }}</span>
            </span>
            <a class="wl-file-act" *ngIf="attachmentUrls[a.url]" [href]="attachmentUrls[a.url]" [attr.download]="a.filename"
              [attr.aria-label]="'Descargar ' + a.filename" title="Descargar">
              <i class="fa-solid fa-download"></i>
            </a>
            <button type="button" class="wl-file-act danger" (click)="removeAttachment(a)" [attr.aria-label]="'Retirar ' + a.filename"
              title="Retirar">
              <i class="fa-solid fa-xmark"></i>
            </button>
          </li>
        </ul>
        <p class="wl-empty" *ngIf="!fileAttachments.length && !uploading">Sin archivos todavía.</p>
      </div>
    </section>

    <!-- Imágenes: las capturas pegadas en la descripción o en un comentario. Ya se ven donde se
         pegaron; aquí se juntan para que ninguna quede imposible de encontrar. Se suben pegándolas,
         por eso esta sección no tiene zona para soltar. -->
    <section class="wl-sec" *ngIf="imageAttachments.length">
      <h3 class="wl-sec-title">
        Imágenes
        <span class="wl-count">{{ imageAttachments.length }}</span>
      </h3>
      <div class="wl-sec-body">
        <div class="wl-atts">
          <div class="wl-att" *ngFor="let a of imageAttachments">
            <div class="wl-att-thumb">
              <img *ngIf="attachmentUrls[a.url]" [src]="attachmentUrls[a.url]" [alt]="a.filename" (click)="openImage(a.url)" />
            </div>
            <span class="wl-att-name" [title]="a.filename">{{ a.filename }}</span>
            <span class="wl-att-meta">
              {{ fileSize(a.size) }}
              <i class="fa-solid fa-xmark" (click)="removeAttachment(a)" title="Retirar de la galería"></i>
            </span>
          </div>
        </div>
      </div>
    </section>

    </div><!-- /wl-col-main -->

    <aside class="wl-col-side">
    <!-- UNA sola tarjeta con pestañas, no dos apiladas.
         La Bitácora es el historial del trabajo y se consulta siempre; los pasos del reporte se
         miran una vez, al reproducir el fallo. Apiladas, la segunda enterraba a la primera en cuanto
         traía sus 60 filas. Con la pestaña conviven sin competir, y de paso la columna gana una
         altura acotada: es lo que permite que scrollee sola y que la caja de comentario no se vaya
         de la pantalla en un ticket largo. -->
    <section class="wl-panel wl-side-panel">
      <div class="wl-panel-head">
        <span class="wl-panel-icon" [class.is-green]="tab === 'activity'" [class.is-blue]="tab === 'trace'">
          <i class="fa-solid" [class.fa-wave-square]="tab === 'activity'" [class.fa-shoe-prints]="tab === 'trace'"></i>
        </span>
        <!-- Sin pestañas cuando no hay nada que alternar: una tarea normal se ve como siempre. -->
        <div class="wl-panel-titles" *ngIf="!hasTrace">
          <span class="wl-panel-eyebrow">Historial</span>
          <h3>Bitácora</h3>
        </div>
        <div class="wl-subtoggle is-compact" *ngIf="hasTrace">
          <button type="button" [class.active]="tab === 'activity'" (click)="tab = 'activity'">
            <i class="fa-solid fa-wave-square"></i> Bitácora
          </button>
          <button type="button" [class.active]="tab === 'trace'" (click)="tab = 'trace'">
            <i class="fa-solid fa-shoe-prints"></i> Pasos del reporte
            <span class="wl-count" *ngIf="traceCount">{{ traceCount }}</span>
          </button>
        </div>
      </div>

      <!-- Los pasos que dio quien reportó, cuando el bug llegó por el botón de reportar. -->
      <app-worklog-trace
        [itemId]="item._id" [itemType]="item.type" [itemCode]="item.code ?? null"
        [hidden]="tab !== 'trace'"
        (loaded)="onTraceLoaded($event)"></app-worklog-trace>

      <div class="wl-act-stream" *ngIf="tab === 'activity'">
        <ng-container *ngFor="let e of activity">

          <!-- Alta: se sintetiza del item, no del historial, para que también aparezca en las
               tareas que existían antes de que el evento se registrara. -->
          <div class="wl-act-row" *ngIf="e.type === 'created'">
            <span class="wl-act-dot created"></span>
            <span class="wl-act-txt"><strong>{{ userName(e.who) }}</strong> registró esta tarea</span>
            <span class="wl-act-when">{{ e.at | date: 'dd MMM, HH:mm' }}</span>
          </div>

          <!-- Comentario: burbuja, con sus imágenes pegadas resueltas -->
          <div class="wl-act-comment" *ngIf="e.type === 'comment'">
            <span class="ava">{{ initials(e.who) }}</span>
            <div class="wl-c-body">
              <span class="wl-c-head">{{ userName(e.who) }} · {{ e.at | date: 'dd MMM, HH:mm' }}</span>
              <app-worklog-rich-text [resolved]="attachmentUrls" [knownUrls]="attachmentRefs" [text]="e.comment?.content" (openImage)="openImage($event)"></app-worklog-rich-text>
            </div>
          </div>

          <!-- Evento del tablero -->
          <div class="wl-act-row" *ngIf="e.type === 'event'">
            <span class="wl-act-dot" [style.background]="eventColor(e.event!)" [title]="eventKindLabel(e.event!)"></span>

            <span class="wl-act-txt">
              <strong>{{ userName(e.who) }}</strong>

              <!-- Racha de campos plegada: una línea con el conteo, expandible -->
              <ng-container *ngIf="e.grouped?.length">&ngsp;
                <a class="wl-act-more" (click)="toggleGroup(e)">
                  actualizó {{ e.grouped!.length }} campos
                  <i class="fa-solid" [ngClass]="isExpanded(e) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                </a>
                <span class="wl-act-group" *ngIf="isExpanded(e)">
                  <span class="wl-act-gline" *ngFor="let g of e.grouped">
                    <span class="wl-h-field">{{ eventPrefix(g) }}:</span>
                    <ng-container *ngIf="!isLongText(g)">
                      <span *ngIf="g.from">{{ eventValue(g, g.from) }} <i class="fa-solid fa-arrow-right"></i> </span>
                      <strong>{{ eventValue(g, g.to) }}</strong>
                    </ng-container>
                    <ng-container *ngIf="isLongText(g)">actualizada</ng-container>
                  </span>
                </span>
              </ng-container>

              <!-- Evento suelto. El &ngsp; es necesario: Angular colapsa el espacio entre elementos
                   y sin él la línea salía como "Arnold Admindescripción:". -->
              <ng-container *ngIf="!e.grouped?.length">&ngsp;
                <!-- Campo de texto libre: se anuncia el cambio, no se vuelca el contenido. Volcarlo
                     metía la URL completa de una imagen pegada dentro de la línea del stream. -->
                <ng-container *ngIf="isLongText(e.event)">actualizó <strong>{{ eventPrefix(e.event!) }}</strong></ng-container>
                <ng-container *ngIf="!isLongText(e.event)">
                  <span class="wl-h-field" *ngIf="eventPrefix(e.event!)">{{ eventPrefix(e.event!) }}:</span>
                  <span *ngIf="e.event!.from">{{ eventValue(e.event!, e.event!.from) }} <i class="fa-solid fa-arrow-right"></i> </span>
                  <strong [style.color]="eventColor(e.event!)">{{ eventValue(e.event!, e.event!.to) }}</strong>
                </ng-container>
              </ng-container>
            </span>

            <span class="wl-act-when">{{ e.at | date: 'dd MMM, HH:mm' }}</span>
            <span class="wl-h-note" *ngIf="e.event?.note">{{ e.event!.note }}</span>

            <!-- Archivo subido: se pinta con su miniatura dentro del stream -->
            <a class="wl-act-file" *ngIf="eventAttachment(e.event) as att" (click)="openImage(att.url)">
              <img *ngIf="isImage(att) && attachmentUrls[att.url]" [src]="attachmentUrls[att.url]" [alt]="att.filename" />
              <span class="wl-act-file-name">{{ att.filename }}</span>
            </a>
          </div>

        </ng-container>
        <p class="wl-empty" *ngIf="!activity.length">Sin actividad todavía.</p>
      </div>

      <!-- Caja de comentario al pie del stream, como en ClickUp. La captura pegada se ve como
           imagen mientras se escribe; antes quedaba la URL del blob a la vista, de 120 caracteres. -->
      <div class="wl-comment-box" *ngIf="tab === 'activity'">
        <app-worklog-editor #commentEditor [(ngModel)]="newComment" [minRows]="2"
          (imagePasted)="onCommentImage($event)"
          [placeholder]="'Escribe un comentario… pega capturas con ' + pasteKey"></app-worklog-editor>
        <button type="button" class="wl-btn primary" [disabled]="!canSendComment" (click)="sendComment()"
          [title]="commentUploads ? 'Espera a que suba la imagen' : 'Comentar'">
          <i class="fa-solid" [class.fa-paper-plane]="!commentUploads" [class.fa-spinner]="commentUploads" [class.fa-spin]="commentUploads"></i>
        </button>
      </div>
    </section>

    </aside><!-- /wl-col-side -->
    </div><!-- /wl-cols -->
  </div>

  <!-- Lightbox de imágenes. `.image-lightbox-dialog` es la clase que el repo ya declara como
       excepción a la normalización de modales (transparente y sin header, a propósito). -->
  <p-dialog [(visible)]="lightboxVisible" [modal]="true" [showHeader]="false" [dismissableMask]="true" styleClass="image-lightbox-dialog">
    <img *ngIf="lightboxUrl && attachmentUrls[lightboxUrl]" [src]="attachmentUrls[lightboxUrl]" alt="Adjunto" style="display:block; max-width:88vw; max-height:88vh;" />
  </p-dialog>

  <div class="wl-loading" *ngIf="loading">
    <i class="fa-solid fa-spinner fa-spin"></i> Cargando…
  </div>
</p-dialog>

<!-- ─────────── Confirmaciones ───────────
     Un sí/no que bloquea se pregunta en su propio diálogo, no en una caja dentro del contenido:
     embutida ahí competía con la tarea, empujaba todo hacia abajo y no se leía como lo que es —el
     paso que hay que resolver antes de seguir. -->

<!-- Borrar es irreversible: se pregunta aparte de cancelar y diciéndolo con todas sus letras. -->
<p-dialog [(visible)]="askingDelete" [modal]="true" [closable]="true" [dismissableMask]="true"
  [draggable]="false" [resizable]="false" [style]="{ width: '480px' }" appendTo="body"
  styleClass="wl-confirm-dialog is-delete" [header]="'¿Borrar ' + (item?.code || 'la tarea') + ' definitivamente?'">
  <p class="wl-confirm-text">
    Se van con ella su historial, sus comentarios y sus adjuntos. Esto no se puede deshacer ni por
    un Admin. Si lo que quieres es descartarla dejando constancia, cancélala.
  </p>
  <ng-template pTemplate="footer">
    <button type="button" class="wl-btn ghost" (click)="dismissDelete()">Volver</button>
    <button type="button" class="wl-btn danger" [disabled]="deleting" (click)="confirmDelete()">
      <i class="fa-solid" [class.fa-trash-can]="!deleting" [class.fa-spinner]="deleting" [class.fa-spin]="deleting"></i>
      Sí, borrar
    </button>
  </ng-template>
</p-dialog>

<!-- Cancelar exige motivo: queda en el historial como la razón del descarte.
     Sin `dismissableMask` porque hay texto escrito de por medio (§ 3.12 de la guía de estilos);
     se cierra con la ✕ o Esc, y `onHide` limpia lo capturado. -->
<p-dialog [(visible)]="askingReason" [modal]="true" [closable]="true" [dismissableMask]="false"
  [draggable]="false" [resizable]="false" [style]="{ width: '520px' }" appendTo="body"
  styleClass="wl-confirm-dialog" header="¿Por qué se cancela?" (onHide)="dismissCancel()">
  <p class="wl-confirm-text">
    Queda registrado en el historial. La tarea se puede reabrir después desde el Historial.
  </p>
  <textarea pInputTextarea [(ngModel)]="cancelReason" rows="3"
    placeholder="Ej. duplicada de la F-008 · ya no aplica tras el cambio de flujo"></textarea>
  <ng-template pTemplate="footer">
    <button type="button" class="wl-btn ghost" (click)="dismissCancel()">Volver</button>
    <button type="button" class="wl-btn danger" [disabled]="!cancelReason.trim()" (click)="confirmCancel()">
      <i class="fa-solid fa-ban"></i> Cancelar tarea
    </button>
  </ng-template>
</p-dialog>

<!-- Fuera del diálogo a propósito: lo dispara el badge de estado, que ahora vive en el encabezado.
     Una referencia de plantilla declarada dentro de una vista embebida no se ve desde otra, así
     que aquí en la raíz es donde alcanzan las dos. Con `appendTo="body"` el render no cambia. -->
<p-overlayPanel #statusPanel styleClass="wl-status-panel" appendTo="body">
  <ng-template pTemplate>
    <span class="wl-sp-title">Mover a</span>
    <button type="button" class="wl-sp-opt" *ngFor="let s of allowedMoves"
      (click)="moveTo(s); statusPanel.hide()">
      <span class="wl-sp-dot" [style.background]="STATUS_META[s].color"></span>
      <i [class]="STATUS_META[s].icon" [style.color]="STATUS_META[s].color"></i>
      {{ STATUS_META[s].label }}
    </button>
  </ng-template>
</p-overlayPanel>
